import { asyncPreactWidget } from '../../utils/async-preact-widget';
import { carouselInline } from '../../preact/widgets';
import { b64DecodeUnicode } from '../../utils/base64-utils';
import { getLabel } from '../../labels/labelling-service';
import { getLocation } from '../../utils/build-urls';

export const CAROUSEL_INLINE_CLASSNAME = '.carouselInline';
const ARTICLE_INFO_CLASSNAME = '.s-article-info';
const ARTICLE_SECTION_CLASSNAME = '.c-article-section';
const HERO_MEDIA_WRAPPER_CLASSNAME = '.c-hero__media-wrapper';
const HERO_DISCLAIMER_CLASSNAME = '.c-hero__disclaimer';
const DISCLAIMER_TEXT_REDIRECT = getLabel('video.article.hero.disclaimer.redirect');

export const initPreactCarousel = () => {
  const widget = asyncPreactWidget(carouselInline);
  if (widget.isOnPage()) {
    widget.start();
    import(`../../preact/widgets/carousel-inline`).then(widget.hydrate).catch(widget.error);
  }
};

export const movePreactCarousel = () => {
  const $carouselInline = document.querySelector(CAROUSEL_INLINE_CLASSNAME);
  const $articleInfo = document.querySelector(ARTICLE_INFO_CLASSNAME);
  const $articleSection = document.querySelector(ARTICLE_SECTION_CLASSNAME);
  if ($carouselInline && $articleSection) {
    if ($articleInfo) {
      $articleInfo.parentNode.insertBefore($carouselInline, $articleInfo.nextSibling);
    } else {
      $articleSection.parentNode.insertBefore($carouselInline, $articleSection.nextSibling);
    }
  }
};

export const renderDisclaimer = (disclaimerText) => {
  const $mediaWrapper = document.querySelector(HERO_MEDIA_WRAPPER_CLASSNAME);
  const $existingDisclaimer = document.querySelector(HERO_DISCLAIMER_CLASSNAME);
  if (!$existingDisclaimer && $mediaWrapper) {
    const $disclaimerDiv = document.createElement('div');
    $disclaimerDiv.className = 'c-hero__disclaimer';
    $disclaimerDiv.textContent = disclaimerText;
    $mediaWrapper.appendChild($disclaimerDiv);
  }
};

export const destroyDisclaimer = () => {
  const $existingDisclaimer = document.querySelector(HERO_DISCLAIMER_CLASSNAME);
  const isRedirectDisclaimer = $existingDisclaimer?.textContent === DISCLAIMER_TEXT_REDIRECT;
  if ($existingDisclaimer && !isRedirectDisclaimer) {
    $existingDisclaimer.remove();
  }
};

export const redirectToFirstVideoUrl = () => {
  const $carouselInline = document.querySelector(CAROUSEL_INLINE_CLASSNAME);
  const carouselData = JSON.parse(b64DecodeUnicode($carouselInline.dataset.jsonBase64));
  const locationWithPathname = getLocation().withPathName;
  const mappedCardList = carouselData?.cardList?.filter((card) => card.url !== locationWithPathname);
  const firstVideo = mappedCardList[0] || undefined;
  if (firstVideo) {
    window.location.href = firstVideo.url;
  }
};
